module.exports = {"maxSwipeTime":300,"minHorizontalSwipeDistance":60,"maxVerticalSwipeDistance":80}


//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/utils/defaults/touch.json
// module id = 1382
// module chunks = 94